/* import __COLOCATED_TEMPLATE__ from './user-summary-user.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  tagName: "li",
});
